import { DotsThreeIcon, XIcon } from '@phosphor-icons/react';
import React from 'react';

import { Button } from '../button/Button';

export interface IFloatingSelectionToolbarProps {
  selectionCount: number;
  isDisabled?: boolean;
  onClear: () => void;
  onOpenActions?: () => void;
  quickActions?: React.ReactNode;
  countLabel?: (n: number) => string;
}

const defaultCountLabel = (n: number) => `${n} geselecteerd`;

export const FloatingSelectionToolbar: React.FC<IFloatingSelectionToolbarProps> = (props) => {
  const { selectionCount, isDisabled, onClear, onOpenActions, quickActions, countLabel = defaultCountLabel } = props;

  if (selectionCount <= 0) {
    return null;
  }

  return (
    <div
      role="toolbar"
      aria-label="Bulk acties"
      className="fixed bottom-4 left-1/2 z-selection-bar flex -translate-x-1/2 items-center gap-2 rounded-lg border border-border bg-surface p-1.5 shadow-lg"
    >
      <button
        type="button"
        onClick={onClear}
        disabled={isDisabled}
        className="flex h-9 items-center gap-2 rounded-md border border-brand-border bg-brand-subtle pl-3 pr-2 text-sm font-medium text-brand-text transition-colors hover:bg-warning-subtle disabled:cursor-default"
      >
        <span>{countLabel(selectionCount)}</span>
        <span className="flex h-5 w-5 items-center justify-center rounded-sm hover:bg-brand-border">
          <XIcon className="h-3 w-3" weight="bold" />
        </span>
      </button>

      {quickActions}

      {onOpenActions && (
        <Button
          color="secondary"
          isDisabled={isDisabled}
          onTrigger={onOpenActions}
          iconLeft={<DotsThreeIcon className="button-icon" weight="bold" />}
        >
          Acties
        </Button>
      )}
    </div>
  );
};
